<template>
    <div class="flex flex-col gap-6 font-proregular text-sm">
        <div class="page-title mb-0">
            {{ localeTextValue("title") }}
        </div>
        <div
            v-if="isBannerVisible"
            class="-mt-5 mb-0 flex items-center gap-4 md:text-lg"
        >
            {{ localeTextValue("banner") }}
        </div>
        <div class="grid grid-cols-2 gap-6 md:grid-cols-4">
            <NuxtLink
                v-for="(item, idx) in config?.[0]?.tiles"
                :key="idx"
                :to="
                    store.mobileMode
                        ? useLocaleValue(item, 'link_mobile')
                        : useLocaleValue(item, 'link')
                "
                target="_blank"
                external
            >
                <div
                    class="aspect-square border border-black-text bg-tile-gray hover:bg-white"
                >
                    <img
                        :src="`${store.staticAssetsBaseUrl}portal/images/pov/${useLocaleValue(item, 'thumbnail')}`"
                        :alt="useLocaleValue(item, 'title')"
                        class="inset-0 z-10"
                    />
                </div>
            </NuxtLink>
        </div>
        <div class="mt-12 border-t border-black-text pt-12">
            <div class="mb-4 font-promedium text-lg">
                {{ localeTextValue("title_1") }}
            </div>
            <div class="font-prolight text-base md:w-2/3">
                <p class="my-4">
                    {{ localeTextValue("subtext_1") }}
                </p>
                <p class="my-4">
                    {{ localeTextValue("subtext_2") }}
                </p>
                <p class="my-4">
                    {{ localeTextValue("subtext_3") }}
                </p>
            </div>
            <div class="mb-4 font-promedium text-lg">
                {{ localeTextValue("title_4") }}
            </div>
            <div class="font-prolight text-base md:w-2/3">
                <p class="my-4">
                    {{ localeTextValue("subtext_5") }}
                </p>
            </div>
            <div class="mb-4 font-promedium text-lg">
                {{ localeTextValue("title_3") }}
            </div>
            <div class="font-prolight text-base md:w-2/3">
                <p class="my-4">
                    {{ localeTextValue("subtext_4")
                    }}<NuxtLink
                        to="mailto:uap@ipr.praha.eu"
                        class="underline underline-offset-2 hover:no-underline"
                        >uap@ipr.praha.eu</NuxtLink
                    >
                </p>
            </div>
        </div>
        <div class="mb-12 border-t border-black-text pt-12">
            <div class="mb-4 font-promedium text-lg">
                {{ localeTextValue("title_2") }}
            </div>
            <div class="font-prolight text-base md:w-2/3">
                <p
                    v-for="(author, idx) in config?.[0]?.authors"
                    :key="idx"
                    class="my-4"
                >
                    <span class="font-promedium"
                        >{{ useLocaleValue(author, "title") }}:</span
                    ><br />
                    <template
                        v-for="name in author.names"
                        :key="name"
                    >
                        {{ name }}<br />
                    </template>
                </p>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const { locale } = useI18n()
const store = useMainStore()

const { data: config } = useFetch<PovConfig[]>("/pov", {
    baseURL: import.meta.client ? store.apiBaseUrl : store.apiBaseUrlInt,
})

const isBannerVisible = computed(() => {
    const currentDate = new Date().getTime()
    if (config.value?.[0]?.bannerDo) {
        const bannerDoDate = new Date(config.value[0].bannerDo).getTime()
        return currentDate <= bannerDoDate
    }
    return true
})

useSeoMeta({
    title: "cisla-pov",
    ogTitle: () =>
        `${locale.value === "cs" ? config.value?.[0]?.texts.title : config.value?.[0]?.texts_en.title} | %siteName`,
})

const localeTextValue = (key: string) => {
    return locale.value === "cs"
        ? config.value?.[0]?.texts[key]
        : config.value?.[0]?.texts_en[key]
}
</script>

<style scoped></style>
